import type { OptionsVisibility } from '@atlassian/ui-modifications-core/types';

import { isNotEmptyString } from '@atlassian/ui-modifications-public-api-utils/is-not-empty-string';

export interface PriorityOption {
    value: string;
    label: string;
    selected: boolean;
    children: PriorityOption[];
}

export const validatePrioritySetValue = (value: string): boolean => isNotEmptyString(value);

export const prioritySetValueTransformer = (optionId: string, options: PriorityOption[]) => {
    const option = options?.find((item) => item.value === optionId);
    const basic = option?.value ?? null;
    return { basic, details: option };
};

export const prioritySetOptionsVisibility = (
    { options, isVisible }: OptionsVisibility,
    lookupValues?: PriorityOption[]
) => {
    return lookupValues?.filter(({ value }) => (isVisible ? options.includes(value) : !options.includes(value)));
};

interface PriorityGetValueTransformerData {
    basic: string;
    details: PriorityOption;
}

// Type guard to check if data has the structure of PriorityGetValueTransformerData
const hasPriorityDetails = (
    data: PriorityGetValueTransformerData | PriorityOption
): data is PriorityGetValueTransformerData => {
    return 'details' in data && 'basic' in data;
};

export const priorityGetValueTransformer = (
    data: PriorityGetValueTransformerData | PriorityOption | null | undefined
) => {
    if (!data) {
        return null;
    }

    if (hasPriorityDetails(data)) {
        // Data has details structure
        return {
            id: data.details.value,
            name: data.details.label,
        };
    }

    // Data is a PriorityOption
    return {
        id: data.value,
        name: data.label,
    };
};
